module.exports = __webpack_public_path__ + "img/investor-openspace.106182b8.png";